import { render, staticRenderFns } from "./Training.vue?vue&type=template&id=4b1602bc"
import script from "./Training.vue?vue&type=script&lang=ts"
export * from "./Training.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports